import { useEffect, useState } from "react";
import { Color } from "../models/helpers/colors.ts";

const ThemeComponent = () => {
    const prefersDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
    const getInitialTheme = () => {
        const savedTheme = localStorage.getItem('data-bs-theme');
        return savedTheme || (prefersDarkMode ? 'dark' : 'light');
    };
    const [theme, setTheme] = useState(getInitialTheme);

    useEffect(() => {
        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

        const handleSystemThemeChange = (e: MediaQueryListEvent) => {
            if (!localStorage.getItem('data-bs-theme')) {
                setTheme(e.matches ? 'dark' : 'light');
            }
        };

        mediaQuery.addEventListener('change', handleSystemThemeChange);

        return () => mediaQuery.removeEventListener('change', handleSystemThemeChange);
    }, []);
    useEffect(() => {
        //bootstrap theme
        document.documentElement.setAttribute('data-bs-theme', theme);

        //status bar theme
        const metaThemeColor = document.querySelector('meta[name="theme-color"]');
        if (metaThemeColor) {
            metaThemeColor.setAttribute('content', theme === 'dark' ? Color.bodyTertiaryDark : Color.bodyTertiary);
        }
    }, [theme]);


    return;
}

export default ThemeComponent;